import { Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { StorageService } from '../../infrastructure';
import { RouterService } from '../general';

@Injectable()
export class OnboardingGuard implements CanActivate {
  constructor(
    private router: RouterService,
    private storageService: StorageService,
    @Inject('ENDPOINTS') private endpoints
  ) {}

  canActivate() {
    const onboardingCompleted = this.storageService.getItem('onboardingCompleted');
    if (onboardingCompleted) {
      return true;
    } else {
      void this.router.navigate([this.endpoints.ONBOARDING]);
      return false;
    }
  }
}
